<template>
  <mdb-container>
    <banner-small :group="group" :title="'New ' + capitalize($tc('common.label.event',1))" v-if="group"/>
    <div class="text-left">
      <summary-editor :hideCancel="true" :summary="summaryEditWork" showHostOption
                      @saveSummary="saveSummary" v-if="group && summaryEditWork.startDate"/>
    </div>
  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import moment from 'moment'
import {mdbContainer} from 'mdbvue';
import BannerSmall from "../group/BannerSmall"
import SummaryEditor from "./SummaryEditor"

export default {
    name: 'Event-Creator',
    components: {
      BannerSmall,
      mdbContainer,
      SummaryEditor,
    },
    data() {
      return {
        summaryEditWork: {
          title: "",
          id: "new",
          startDate: null,
          endDate: null,
          updated: false,
          hideEndTime: false,
          publicTitle: "",
          setAsHost: true
        }

      }
    },
    computed: {
      userDetails() {
        return this.$store.state.userDetails
      },
      settings() {
        return this.$store.state.settings
      },
      group() {
        return this.$store.state.currentGroup
      }
    },
    mounted() {
      api.groupBasics(this.$route.params.id, "event organizer")
      let start = moment().add(14, 'd').set('h', 18).set('m', 0).set('s',0).set('ms',0)
      this.summaryEditWork.startDate = start.toDate()
      let end = start.add(2,'h')
      this.summaryEditWork.endDate = end.toDate()
    },
    methods: {
      saveSummary: function (newSummary) {
        this.$router.push("/event/show/" + newSummary.id)
      }
    }
  }
</script>
